<template>
    <div id="RegistForm" class="base">
        <div class="title-area">
            <div style="font-size: 24px; color: whitesmoke">Philips Care Portal</div>    
            <div style="font-size: 24px; color: whitesmoke">申込みフォーム </div>
        </div>
        <div v-if="isAgreed == false" class="agreement-area">
            <div id="item-contens">
                <div class="card-content ">
                    <div>
                        <span style="font-size:20px; color:whitesmoke;">利用規約</span>
                        <a @click="download"><b-icon style="margin-top:3px; color:whitesmoke;" icon="file-download-outline"/></a>
                    </div>                    
                    <table>
                        <tr><td><textarea readonly class="cautionArea noresize" v-model="agreement" /></td></tr>
                        <tr><td><div  style="text-align: center;"><b-checkbox class="cstmCheckBox" v-model="isAgree" :disabled="!canAgree">利用規約に同意のうえ、申込みを行う。</b-checkbox></div></td>
                        </tr>
                    </table>
                </div>
            </div>
            <b-button class="opbutton" @click="agree" :disabled="!isAgree">申込みを行う</b-button>
        </div>
        <div v-else-if="isSendMail == false" class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 20px; color: whitesmoke">登録用のメールアドレスを入力してください。</div>
                    <table >
                        <tr><th style="width:180px;"></th><td></td></tr>
                        <tr><th style="width:180px;">メールアドレス<span class="require" /></th><td><input type="text" v-model="mail" placeholder="例) example@example.co.jp" maxlength="100"/></td></tr>
                        <tr><th style="width:180px;"></th><td>ログインIDとして使用します。受信可能なメールアドレスを入力してください。</td></tr>
                        <tr><th style="width:180px;"></th><td>※有効期限は2時間となっています。</td></tr>
                        <tr><th style="width:180px;"></th><td>　有効期限内に送信されたメールからURLにアクセスして<br>　登録を行ってください。</td></tr>
                    </table>
                </div>
            </div>
            <b-button class="sendmailButton" @click="sendmail" :disabled="!mail">確認メールを送信する</b-button>
        </div>
        <div v-else class="regist-area">
            <div id="item-contens">
                <div class="card-content">
                    <div style="font-size: 18px; color: whitesmoke; margin:20px 0;">
                        入力されたメールアドレス宛に確認メールを送信しました。<br>
                        メールに記載されたURLにアクセスして登録を続けてください。<br>
                    </div>
                    <div style="font-size: 13px; color: whitesmoke; margin:20px 30px;text-align: left;">
                        ※メールの送信には数分かかる場合があります。左記時間を経過しても受信できない場合、以下の事項を確認して再度登録を行ってください。
                        <ul style="list-style: disc; margin-left: 20px;">
                            <li>入力したメールアドレスが正しいことを確認してください。</li>
                            <li>メールソフト、メールサービス、セキュリティソフトの設定によっては、自動的に既読、ごみ箱に移行される場合があります。ご利用のメールソフト、メールサービス、セキュリティソフトの設定をご確認ください。</li>
                            <li>迷惑メールの対策などでドメイン指定を行っている場合、メールを受信できない場合があります。「@src-order.com」を受信可能な設定に変更してください。</li>
                        </ul>
                    </div>
                </div>
                <div v-if="isShowUrl" class="card-content">
                    <div style="font-size: 18px; color: whitesmoke; margin:20px 0; overflow-wrap:anywhere;">
                        開発環境向け　登録用URL<br>
                        {{tarUrl}}<br>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {consentStatement} from "@/components/mock/base/const.js";
const validator = require('validator')

export default {
  name: "RegistForm",
  data() {
    var env = this.$store.state.env;
    //pathでどこからの申込みか判断する。
    var path = this.$route.path
    return {
        env: env,
        agreement:null,
        canAgree:false,
        isAgree: false,
        isAgreed: false,
        isSendMail: false,
        isShowUrl: false,
        tarUrl: "",
        mail: "",
        path: path,
    };
  },
  methods: {
    agree: function() {
        this.isAgreed = true;
    },
    sendmail: function() {
      if (validator.isEmail(String(this.mail))) {
        this.$store.dispatch("sendConfirmationMail", {
            mail: this.mail,
            apiPath: this.path
        }).then(result => {
            if(result != null && result.status === 200 ) {
                this.isSendMail = true;
                if (this.env == "development") {
                    this.isShowUrl  = true;
                    this.tarUrl = result.obj.url;
                }
            } else if (result != null && (result.status === 400 || result.status === 401 || result.status === 500)){
                var message = "予期しないエラーが発生しました。"
                if(result.response && result.response.body && result.response.body.message){
                    message = result.response.body.message
                } else if(result.message){
                    message = result.message
                }
                this.showErrorMessage(message)
            } else {
                this.showErrorMessage("予期しないエラーが発生しました。")
            }
        });
      } else {
        this.showErrorMessage("有効なメールアドレスの形式で入力してください。")
      }
    },
    download: function(){
        this.$store.dispatch("downloadConsentStatement", {
            type: consentStatement.registPage,
            uid: 0
        }).then(result => {
            if(!result.status || result.status != 200){
                if(result.obj){
                    this.showErrorMessage(result.obj.message);
                } else {
                    this.showErrorMessage(result.message);
                }
            }
        }).catch(error => {
            this.showErrorMessage(error);
        });
    },
  },
  computed: {
  },
  mounted: function(){
    //backgroundの変更
    document.documentElement.style.background = "rgb(0, 114, 218)";
    this.$store.dispatch("getConsentStatement", {
        type: consentStatement.registPage,
    }).then(result => {
      console.log(result);
      this.agreement ="利用規約が登録されていません。"
      if(result != null && result.status === 200 ) {
        if(result.body.contents != ""){
            this.agreement = result.body.contents;
            this.canAgree = true;
        }
      }
    }).catch(error => {
        this.agreement ="利用規約を取得できませんでした。"
    });
  }
};
</script>
<style lang="scss" scoped>
.base {
    padding-bottom: 50px;
}
.title-area{
    padding-top:50px;
    margin-bottom:25px;
}
.regist-area{
    width: 600px;
}
.auth-area {
    width: 300px;
}
.regist-area,
.auth-area {
    margin : 0 auto;
}
.card-content {
    border-color: whitesmoke !important;
    margin-bottom:5px;
}
.agreement-area {
    margin : 0 auto;
    width:1000px;
    height:400px;
}
.card-content table th,
.card-content table td,
.cstmCheckBox:hover
{
    color: whitesmoke !important;
}
.regist-area > input,
.auth-area > input{
    margin-bottom:10px;
}
.authFaild{
    margin-top:5px;
    color:tomato;
}
.require::after{
    color:tomato;
}
.opbutton {
    margin-top:10px;
    width: 150px;
}
.sendmailButton {
    margin-top:10px;
    width: 200px;
}
.innerButton{
  margin-top:10px;
}
.nameInput {
  width: 176px !important;
}
.passInput {
  width: 250px !important;
}
.passButton {
  margin-left:5px;
  width:100px !important;
  height:29px !important;
}

</style>



// WEBPACK FOOTER //
// src/components/mock/guest/regist/RegistForm.vue